import { Link } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import SEO from "@/components/SEO";
import { XCircle, ArrowLeft, ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function CheckoutCanceled() {
  return (
    <Layout>
      <SEO title="Checkout Canceled" description="Your checkout was canceled. Your cart is saved." canonical="/checkout/canceled" />
      <div className="container flex flex-col items-center py-24 text-center">
        <XCircle className="h-20 w-20 text-destructive" />
        <h1 className="mt-6 font-display text-3xl font-bold">Checkout Canceled</h1>
        <p className="mt-3 max-w-md text-muted-foreground">
          Your checkout was canceled and no charges were made. Your cart items are still saved.
        </p>

        <div className="mt-8 flex items-start gap-3 rounded-lg border bg-card p-4 text-left">
          <ShoppingCart className="mt-0.5 h-5 w-5 shrink-0 text-muted-foreground" />
          <div>
            <p className="text-sm font-semibold">Your cart is saved</p>
            <p className="text-sm text-muted-foreground">Return to checkout anytime.</p>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Button asChild className="bg-accent text-accent-foreground hover:bg-accent/90">
            <Link to="/cart">
              <ArrowLeft className="mr-2 h-4 w-4" /> Back to Cart
            </Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/shop">Continue Shopping</Link>
          </Button>
        </div>

        <p className="mt-8 text-xs text-muted-foreground">
          Having trouble?{" "}
          <a href="mailto:nick@moonriversigns.com" className="text-accent hover:underline">
            nick@moonriversigns.com
          </a>
        </p>
      </div>
    </Layout>
  );
}